<template>
    <div class="recruitDetails-body-box transition">
        <div class="recruitDetails-top-box transition">
            <h4>{{post_name}}</h4>
        </div>
        <div class="recruitDetails-content-box transition">
            <div class="recruitDetails-table-box col-12">
                <ul class="recruitDetails-table1 list-unstyled col-12 list-group list-group-horizontal">
                    <li class="recruitDetails-table-title col-3">
                        发布时间:
                    </li>
                    <li class="col-9 recruitDetails-table-content">
                        {{ create_time }}
                    </li>
                </ul>

                <ul class="recruitDetails-table2 list-unstyled col-12 list-group list-group-horizontal transition">
                    <li class="recruitDetails-table-title col-3">
                        工作年限:
                    </li>
                    <li class="col-9 col-lg-2 recruitDetails-table-content">
                        {{working_life}}
                    </li>
                    <li class="recruitDetails-table-title col-3 col-lg-2">
                        学历要求:
                    </li>
                    <li class="col-5 col-lg-3 recruitDetails-table-content">
                        {{education}}
                    </li>
                    <li class="recruitDetails-table-title col-3 col-lg-1">
                        招聘人数:
                    </li>
                    <li class="col-1 recruitDetails-table-content">
                        {{recruit_number}}
                    </li>
                </ul>

                <ul class="recruitDetails-table3 list-unstyled col-12 list-group list-group-horizontal transition">
                    <li class="recruitDetails-table-title col-3">
                        所属集团:
                    </li>
                    <li class="col-9 recruitDetails-table-content">
                        {{serving_company}}
                    </li>
                </ul>

                <ul class="recruitDetails-table4 list-unstyled col-12 list-group list-group-horizontal transition">
                    <li class="recruitDetails-table-title col-3">
                        工作地点:
                    </li>
                    <li class="col-9 recruitDetails-table-content">
                        {{place}}
                    </li>
                </ul>
            </div>

            <div class="recruitDetails-introduce-box transition">
                <h4 class="recruitDetails-introduce-title">
                    岗位描述:
                </h4>

                <span class="col-12">
                    {{job_description}}
                </span>

                <h4 class="recruitDetails-introduce-title">
                    任职要求:
                </h4>

                <span class="col-12">
                    {{job_requirements}}
                </span>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            create_time:'',
            post_name:'',
            working_life:'',
            education:'',
            recruit_number:'',
            serving_company:'',
            place:'',
            job_description:'',
            job_requirements:''
        }
    },
    mounted() {
        this.create_time=this.$route.query.create_time
        this.post_name=this.$route.query.post_name
        this.working_life=this.$route.query.working_life
        this.education=this.$route.query.education
        this.recruit_number=this.$route.query.recruit_number
        this.serving_company=this.$route.query.serving_company
        this.place=this.$route.query.place
        this.job_description=this.$route.query.job_description
        this.job_requirements=this.$route.query.job_requirements
    }
}
</script>

<style scoped>
.recruitDetails-table2{
    display: flex;
    flex-wrap: wrap;
}

.recruitDetails-introduce-box {
    margin-bottom: 3rem;
}

.recruitDetails-introduce-box>span {
    font-size: 1.25rem;
    color: #000;
}

.recruitDetails-introduce-title {
    margin-top: 3rem;
    margin-bottom: 1rem;
    font-size: 1.5rem;
    color: #000;
}

.recruitDetails-table-content {
    padding-left: 1.2rem;
}

.recruitDetails-table-title {
    background: #f9fbfd;
    text-align: center;
}

.recruitDetails-table-box {
    font-size: 1rem;
    margin-bottom: 2rem;
}

.recruitDetails-table-box>ul>li {
    height: 3.375rem;
    border: 1px solid #e5e9f2;
    line-height: 3.375rem;
}

.recruitDetails-top-information {
    color: #777777;
    margin-top: 0.7rem;
}

.recruitDetails-top-information-time {
    margin-right: 1rem;
}

.recruitDetails-top-box {
    text-align: center;
    margin-bottom: 1.5rem;
    width: 100vw;
}

.recruitDetails-top-box>h4 {
    font-size: 1.8rem;
}

.recruitDetails-body-box {
    margin-top: 2rem;
    width: 100vw;
    margin-top: 13rem;
    height: auto;
}

.recruitDetails-content-box {
    width: 62.5rem;
    margin: 0 auto;
    padding-top: 2rem;
    border-top: 1px solid #777777;
}

.recruitDetails-content-box>p>span {
    font-size: 1.1rem !important;
}

.recruitDetails-content-box>p>span>img {
    margin-top: 0.3rem;
}

@media screen and (max-width:1045px) {
    .recruitDetails-top-box {
        width: 95%;
        margin: 0 auto 1.5rem auto;
    }

    .recruitDetails-content-box {
        width: 95%;
        margin: 0 auto;
    }
}

@media screen and (max-width:991px) {
    .recruitDetails-body-box {
        margin-top: 8rem;
    }

    .recruitDetails-content-box {
        width: 92%;
        margin: 0 auto;
    }

    .recruitDetails-top-box {
        width: 80%;
        margin: 0 auto 1.5rem auto;
    }

    .recruitDetails-content-box>p>span>img,
    .recruitDetails-content-box>p>img {
        width: 100% !important;
        height: auto !important;
    }

    .recruitDetails-content-box>p {
        text-indent: 0 !important;
    }

    .recruitDetails-table-content{
        padding-left: 0.5rem;
    }
}

@media screen and (max-width:540px) {
    .recruitDetails-table-box{
        font-size: 0.8rem;
    }

    .recruitDetails-top-box>h4 {
        font-size: 1.2rem;
    }

    .recruitDetails-content-box>p>span>img,
    .recruitDetails-content-box>p>img {
        width: 100% !important;
        height: auto !important;
    }

    .recruitDetails-content-box>p {
        text-indent: 0 !important;
    }

    .recruitDetails-introduce-title{
        font-size: 1.25rem;
    }

    .recruitDetails-introduce-box>span{
        font-size: 0.9rem;
    }
}
</style>